import React, {useState} from "react"
import {Input} from "@material-ui/core"

import {HeaderFormControl} from "./Header"

function TextFilter({autoFocus, value = "", placeholder, onChange, onEnterKeyDown}) {
	const [local, setLocal] = useState({value})

	function handleChange(e) {
		setLocal({
			...local,
			value: e.target.value,
		})
		if (onChange) {
			onChange(e)
		}
	}

	function handleKeyDown(e) {
		if (onEnterKeyDown && e.key === "Enter") {
			e.preventDefault()
			onEnterKeyDown(e)
		}
	}

	return (
		<HeaderFormControl>
			<Input
				autoFocus={autoFocus}
				placeholder={placeholder}
				value={local.value}
				onChange={handleChange}
				onKeyDown={handleKeyDown}
			/>
		</HeaderFormControl>
	)
}

export {TextFilter}
